export const NotificationTargetType = {
	Email: 1,
	Push: 2,
	Webhook: 3,
	SMS: 4,
	Whatsapp: 5,
	Telegram: 6,
};

export const NotificationTargetTypeNames = {
	[NotificationTargetType.Email]: "Email",
	[NotificationTargetType.Push]: "Push",
	[NotificationTargetType.Webhook]: "Webhook",
	[NotificationTargetType.SMS]: "SMS",
	[NotificationTargetType.Whatsapp]: "Whatsapp",
	[NotificationTargetType.Telegram]: "Telegram",
};

export const NotificationCategory = {
	BackupUploaded: 1,
	BackupImported: 2,
	ModuleAlarm: 3,
	ModuleOffline: 4,
	ModuleOnline: 5,
	ModulePanic: 6,
	ModuleUserReceived: 7,
	ModuleUserPictureReceived: 8,
	ModuleAccessReceived: 9,
	ModuleAccessGroupReceived: 10,
	ModuleUnitReceived: 11,
	ModuleCommandReceived: 12,
	AuthFailedAlert: 13,
	AuthNewLoginAlert: 14,
	Auth2FADisabledAlert: 15,
	AuthResetPasswordLink: 16,
	AuthPasswordChangedAlert: 17,
	NewInvitation: 18,
	AuthEmailConfirmation: 19,
	AccountCreated: 20,
	OrganizationCreated: 21,
	UnitCreated: 22,
	LicenseReceived: 23,
	LicenseSerialNumberLinked: 24,
};

export const NotificationCategoryNames = {
	[NotificationCategory.BackupUploaded]: "Backup enviado",
	[NotificationCategory.BackupImported]: "Backup importado",
	[NotificationCategory.ModuleAlarm]: "Alarme do módulo acesso",
	[NotificationCategory.ModuleOffline]: "Módulo acesso Offline",
	[NotificationCategory.ModuleOnline]: "Módulo acesso Online",
	[NotificationCategory.ModulePanic]: "Pânico módulo acesso",
	[NotificationCategory.ModuleUserReceived]: "Usuário recebido",
	[NotificationCategory.ModuleUserPictureReceived]: "Foto de usuário recebida",
	[NotificationCategory.ModuleAccessReceived]: "Ponto de acesso recebido",
	[NotificationCategory.ModuleAccessGroupReceived]: "Grupo de acesso recebido",
	[NotificationCategory.ModuleUnitReceived]: "Unidade recebida",
	[NotificationCategory.ModuleCommandReceived]: "Comando recebido",
	[NotificationCategory.AuthFailedAlert]: "Falha no login",
	[NotificationCategory.AuthNewLoginAlert]: "Novo login",
	[NotificationCategory.Auth2FADisabledAlert]: "2FA desabilitado",
	[NotificationCategory.AuthResetPasswordLink]: "Link de redefinição de senha",
	[NotificationCategory.AuthPasswordChangedAlert]: "Senha alterada",
	[NotificationCategory.AuthEmailConfirmation]: "Confirmação de email",
	[NotificationCategory.NewInvitation]: "Novo convite",
	[NotificationCategory.AccountCreated]: "Conta criada",
	[NotificationCategory.OrganizationCreated]: "Organização criada",
	[NotificationCategory.UnitCreated]: "Unidade criada",
	[NotificationCategory.LicenseReceived]: "Licença recebida",
	[NotificationCategory.LicenseSerialNumberLinked]: "Número de série da licença vinculado",
};

export const NotificationPriority = {
	Low: 1,
	Medium: 2,
	High: 3,
	Critical: 4,
};

export const NotificationPriorityNames = {
	[NotificationPriority.Low]: "Low",
	[NotificationPriority.Medium]: "Medium",
	[NotificationPriority.High]: "High",
	[NotificationPriority.Critical]: "Critical",
};

export const NotificationSource = {
	ModuleEvents: 1,
	Identity: 2,
	Backups: 3,
	AccessControl: 4,
};

export const NotificationSourceNames = {
	[NotificationSource.ModuleEvents]: "ModuleEvents",
	[NotificationSource.Identity]: "Identity",
	[NotificationSource.Backups]: "Backups",
	[NotificationSource.AccessControl]: "AccessControl",
};